// extracted by mini-css-extract-plugin
export default {"hello":"Hello_hello__zOdcf","typed":"Hello_typed__WA2QZ","helloImg":"Hello_helloImg__aQTNk","btnHello":"Hello_btnHello__-nYY9","glow":"Hello_glow__H+O17"};